export default {
  // option的结构一般是 {value, text}
  // 以value的值为id后缀
  // 举例:  {value: "sum", text: "Show Sum Value：SUM"}
  // 'common_options_sum': 'Show Sum Value：SUM',

  // Show More Statistics 下拉多选筛选器的选项
  'common_options_sum': '汇总值',
  'common_options_avg_no_null': '均值(去空)',
  'common_options_avg_no_null_zero': '均值(去空和0)',
  'common_options_max': '最大值',
  'common_options_min': '最小值',
  'common_options_count': '计数',
  'common_options_avg': '平均值',

  // 其他
  'common_options_value_only': "仅展示指标值",
  'common_options_show_change': "展示变化率",
  'common_options_show_dod': "展示环比",
  'common_options_show_sdlw': "展示同比",
  'common_options_show_wow': "展示环比",
  'common_options_show_mom': "展示环比",
  'common_options_show_swlm': "展示同比",
  'common_options_show_smly': "展示同比",
  'common_yes': "是",
  'common_no': "否",
};
